import * as React from "react";
const IconIdeaBriefcase = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M32.3 23.4c-2.8-.1-5.5 1-7.5 3s-3.1 4.6-3.1 7.5c0 3.6 1.8 6.9 4.9 8.8.6.4.9 1.1.9 1.8v1.8c0 2.3 1.8 4.1 4.1 4.1h1c2.3 0 4.1-1.8 4.1-4.1v-1.9c0-.4.1-.7.3-1s.4-.5.7-.7c3-1.9 4.8-5.1 4.9-8.6.1-2.8-1-5.4-2.9-7.4-2.1-2.1-4.7-3.2-7.4-3.3m2.3 22.9c0 1.2-.9 2.1-2.1 2.1h-1c-1.2 0-2.1-.9-2.1-2.1V44h5.2v2.3m1.9-5.3c-.4.3-.8.6-1.1 1h-6.8c-.3-.4-.6-.7-1.1-1-2.5-1.6-4-4.2-4-7.2 0-2.3.9-4.4 2.5-6 1.6-1.5 3.7-2.4 5.9-2.4h.2c2.2.1 4.3 1 5.9 2.7s2.4 3.8 2.3 6c0 2.8-1.4 5.4-3.8 6.9" />
    <path d="M56 14.9H42.4V9.1c0-2.2-1.8-4-4-4H25.6c-2.2 0-4 1.8-4 4v5.8H8c-3.3 0-6 2.7-6 6v32c0 3.3 2.7 6 6 6h48c3.3 0 6-2.7 6-6v-32c0-3.3-2.7-6-6-6M23.6 9.1c0-1.1.9-2 2-2h12.8c1.1 0 2 .9 2 2v5.8H23.6zM60 52.9c0 2.2-1.8 4-4 4H8c-2.2 0-4-1.8-4-4v-32c0-2.2 1.8-4 4-4h48c2.2 0 4 1.8 4 4z" />
  </svg>
);
export default IconIdeaBriefcase;
